



















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class PartTabs extends Vue {
  active: string = '';

  get tabs() {
    return this.$slots;
  }

  private mounted() {
    this.active = Object.keys(this.tabs)[0];
  }
}
